// @deprecated
export * from 'ui.system.menu.vue';
